import { useEffect } from 'react';

function Toast({ message, type = 'success', onClose }) {
    try {
        useEffect(() => {
            const timer = setTimeout(() => {
                onClose();
            }, 2000);

            return () => clearTimeout(timer);
        }, [onClose]);

        const getToastStyles = () => {
            switch (type) {
                case 'success':
                    return 'bg-green-500';
                case 'error':
                    return 'bg-red-500';
                default:
                    return 'bg-gray-400';
            }
        };

        return (
            <div 
                className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg flex items-center space-x-2 z-50 ${getToastStyles()}`}
                data-name="toast"
            >
                <i className={`fas ${type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'} mr-2`}></i>
                <span>{message}</span>
            </div>
        );
    } catch (error) {
        console.error('Toast component error:', error);
        reportError(error);
        return null;
    }
}

export default Toast;